export enum DatePickerModeEnum {
    Month,
    Date
}



// WEBPACK FOOTER //
// C:/Visual Studio Projects/Novicell Performance Platform/PerformancePlatform/Novicell.Performance.Website/ui/src/app/models/DatePickerModeEnum.ts